import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'

import { addToast } from 'containers/Toasts/actions'

import {
  fetchTagsCanBeAddedError,
  fetchTagsCanBeAddedSuccess,
  fetchTagsCanBeRemovedError,
  fetchTagsCanBeRemovedSuccess,
  formSubmitError,
  formSubmitSuccess,
} from './actions'
import {
  FETCH_TAGS_CAN_BE_ADDED_ASYNC,
  FETCH_TAGS_CAN_BE_REMOVED_ASYNC,
  TAGS_FORM_SUBMIT_ASYNC,
  TYPE_OF_FORM,
} from './constants'

const formSubmitEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(TAGS_FORM_SUBMIT_ASYNC.INITIATE)
    .mergeMap(() => {
      const state = store.getState()
      const profileIds = Object.keys(state.mailboxes.management.selectedMailboxesMap)
      const tagsToInclude =
        state.mailboxes.tagsForm.typeOfForm === 1
          ? state.mailboxes.tagsForm.tagsCanBeAdded.items.filter((elem) => elem.type !== null)
          : state.mailboxes.tagsForm.tagsCanBeRemoved.items.filter((elem) => elem.type !== null)

      const tagsMap = tagsToInclude.reduce(
        (acc, elem) => (!acc ? { [elem.id]: elem.name } : { ...acc, [elem.id]: elem.name }),
        {}
      )

      const restOpt = {
        selectAll: state.mailboxes.management.selectAll,
        typeFilter: state.mailboxes.management.typeFilter,
        protectedFilter: state.mailboxes.management.protectedFilter,
        tagsFilter: state.mailboxes.management.selectAll
          ? store
              .getState()
              .mailboxes.management.tagsFilter.map((elem) => elem.value)
              .join(',')
          : '',
        segmentsFilter: state.mailboxes.management.selectAll
          ? store
              .getState()
              .mailboxes.management.segmentsFilter.map((elem) => elem.value)
              .join(',')
          : '',
        riskLevelsFilter: state.mailboxes.management.selectAll
          ? store
              .getState()
              .mailboxes.management.riskLevelsFilter.map((elem) => elem.value)
              .join(',')
          : '',
        search: state.mailboxes.management.search,
      }

      if (state.mailboxes.tagsForm.typeOfForm === TYPE_OF_FORM.ADD) {
        return api.mailboxes.assignTags(state.partnerOptions.selectedCompany?.value, {
          profileIds,
          tagNames: state.mailboxes.tagsForm.toAddTags.map(
            (elem) => tagsMap[elem.value] || elem.label
          ),
          ...restOpt,
        })
      }
      return api.mailboxes.removeTags(state.partnerOptions.selectedCompany?.value, {
        profileIds,
        tagNames: state.mailboxes.tagsForm.toRemoveTags.map(
          (elem) => tagsMap[elem.value] || elem.label
        ),
        ...restOpt,
      })
    })
    .mergeMap(({ response }) =>
      Observable.of(
        formSubmitSuccess(response || {}),
        addToast({
          message: 'Tags updated successfully!',
        })
      )
    )
    .catch((error) => Observable.of(epicsErrorHandler(formSubmitError, error)))
    .takeUntil(action$.ofType(TAGS_FORM_SUBMIT_ASYNC.CANCEL))

const fetchTagsCanBeAddedEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_TAGS_CAN_BE_ADDED_ASYNC.INITIATE)
    .filter((action) => {
      if (action.type === FETCH_TAGS_CAN_BE_ADDED_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.management) !== -1
      return true
    })
    .mergeMap(() =>
      api.mailboxes
        .getTagsToModify({
          companyId: store.getState().partnerOptions.selectedCompany?.value,
          mode: 'add',
          page: store.getState().mailboxes.tagsForm.tagsCanBeAdded.page,
          search: store.getState().mailboxes.tagsForm.tagsCanBeAdded.search,
          allProfiles: store.getState().mailboxes.management.selectAll,
          profileIds: store.getState().mailboxes.management.selectAll
            ? []
            : Object.keys(store.getState().mailboxes.management.selectedMailboxesMap),
        })
        .map((response) => fetchTagsCanBeAddedSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchTagsCanBeAddedError, error)))
        .takeUntil(action$.ofType(FETCH_TAGS_CAN_BE_ADDED_ASYNC.CANCEL))
    )

const fetchTagsCanBeRemovedEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_TAGS_CAN_BE_REMOVED_ASYNC.INITIATE)
    .filter((action) => {
      if (action.type === FETCH_TAGS_CAN_BE_REMOVED_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.management) !== -1
      return true
    })
    .mergeMap(() =>
      api.mailboxes
        .getTagsToModify({
          companyId: store.getState().partnerOptions.selectedCompany?.value,
          mode: 'remove',
          page: store.getState().mailboxes.tagsForm.tagsCanBeRemoved.page,
          search: store.getState().mailboxes.tagsForm.tagsCanBeRemoved.search,
          allProfiles: store.getState().mailboxes.management.selectAll,
          profileIds: Object.keys(store.getState().mailboxes.management.selectedMailboxesMap),
        })
        .map((response) => fetchTagsCanBeRemovedSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchTagsCanBeRemovedError, error)))
        .takeUntil(action$.ofType(FETCH_TAGS_CAN_BE_REMOVED_ASYNC.CANCEL))
    )

export default combineEpics(formSubmitEpic, fetchTagsCanBeAddedEpic, fetchTagsCanBeRemovedEpic)
